import React from 'react';
import styled from '@emotion/styled';

const SlotWrapper = styled.div`
  width: 192px;
  height: 58px;
  background: ${props => props.selected ? '#EDEDED' : '#151515'};
  border: 1px solid #151515;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 24px;
  margin-bottom: 16px;
  cursor: pointer;
  box-shadow: ${props => props.selected ? '0px 1px 15px rgba(69, 65, 78, 0.08)' : 'none'};
  transition: background 0.2s, box-shadow 0.2s;
`;

const Dot = styled.div`
  width: 10px;
  height: 10px;
  background: #F43F60;
  border-radius: 50%;
  margin-right: 16px;
`;

const TimeText = styled.div`
  color: ${props => props.selected ? '#1C1C1C' : '#EDEDED'};
  font-size: 14px;
  font-family: 'Clash Grotesk', sans-serif;
  font-weight: 500;
  text-transform: uppercase;
`;

function TimeSlot({ start, end, isSelected, onSelect, onDeselect }) {
    const handleClick = () => {
        if (isSelected) {
            onDeselect && onDeselect();
        } else {
            onSelect && onSelect();
        }
    };
    return (
        <SlotWrapper selected={isSelected} onClick={handleClick}>
            <Dot />
            <TimeText selected={isSelected}>{start} - {end}</TimeText>
        </SlotWrapper>
    );
}

export default TimeSlot;